module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("file-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "file-modal",
    attrs: {
      "width": "1000px",
      "value": _vm.showModal,
      "effect": "fade",
      "backdrop": false,
      "large": ""
    },
    on: {
      "closed": function($event) {
        _vm.closed('event')
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0px 20px",
      "font-weight": "800"
    }
  }, [_vm._v("PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    staticStyle: {
      "height": "450px",
      "overflow-y": "auto"
    }
  }, [_c('div', [(_vm.error_msg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.error_msg)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error_msg.length == 0) ? _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, _vm._l((_vm.existingFiles), function(f) {
    return _c('div', {
      key: f.seq_id,
      staticStyle: {
        "width": "220px",
        "float": "left",
        "margin": "4px",
        "height": "250px",
        "word-wrap": "break-word"
      }
    }, [_c('center', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editFile(f)
        },
        "dblclick": function($event) {
          _vm.editAndOpenFile(f)
        }
      }
    }, [_c('pdf', {
      staticStyle: {
        "display": "inline-block",
        "width": "100px",
        "border": "solid #ccc 1px"
      },
      attrs: {
        "src": '/api/file_upload/pdf_load/' + f.seq_id + '?file=' + f.file_path + '&name=' + f.display_file_name
      },
      on: {
        "error": _vm.pdfRenderError
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(f.display_file_name))], 1)])], 1)
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white",
      "height": "100px"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row no_focus"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "height": "35px"
    }
  }, [(_vm.editFileSelect) ? _c('div', {
    staticStyle: {
      "float": "left",
      "padding-bottom": "15px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.editFileSelectItem.display_file_name) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 row no_focus"
  }, [_c('div', {
    staticClass: "col-xs-6 no_focus"
  }, [(_vm.editFileSelect) ? _c('a', {
    ref: "selected_file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "selected_file",
      "id": "selected_file",
      "href": '/api/file_upload/pdf_load/' + _vm.editFileSelectItem.seq_id + '?file=' + _vm.editFileSelectItem.file_path + '&name=' + _vm.editFileSelectItem.display_file_name,
      "target": 'file' + _vm.editFileSelectItem.seq_id
    }
  }, [_vm._v(_vm._s(_vm.editFileSelectItem.display_file_name))]) : _vm._e(), _vm._v(" "), (_vm.editFileSelect) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#92D050",
      "border-color": "#92D050",
      "float": "left"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openFile()
      }
    }
  }, [_vm._v("閲覧")]) : _vm._e(), _vm._v(" "), (_vm.editFileSelect) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "disabled": _vm.disableEditonButtons,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.renameFile()
      }
    }
  }, [_vm._v("名称変更")]) : _vm._e(), _vm._v(" "), (_vm.editFileSelect) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#FF7C80",
      "border-color": "#FF7C80",
      "float": "left"
    },
    attrs: {
      "disabled": _vm.disableEditonButtons,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile()
      }
    }
  }, [_vm._v("削除")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "pdf_file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "pdf_file",
      "id": "pdf_file",
      "data-cy": "pdf_file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.fileSelected,
      "click": _vm.fileClicked
    }
  }), _vm._v(" "), (_vm.uploading == true) ? _c('div', [_c('span', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  }), _vm._v("\n              アップロード中...\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showUploadFile) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "120px",
      "width": "10%"
    },
    attrs: {
      "data-cy": "upload_btn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.uploadFile({})
      }
    }
  }, [_vm._v("アップロード")]), _vm._v(" "), (_vm.showCancelUpload) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "120px",
      "width": "10%",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (this.selected_file_name != null && _vm.showUploadFile) ? _c('label', [_vm._v(_vm._s(this.selected_file_name))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 no_focus"
  }, [(_vm.showChoseFile) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "200px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableEditonButtons
    },
    on: {
      "click": _vm.choseFile
    }
  }, [_vm._v("ファイルを選択（PDF）")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('button')
      }
    }
  }, [_vm._v("戻る")])])])])])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmToDeleteFile"
    },
    on: {
      "done": _vm.deleteFileConfirmed
    }
  }), _vm._v(" "), _c('input-modal2', {
    attrs: {
      "tag": "inputFileRename"
    },
    on: {
      "closed": _vm.renameFileConfirmed
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66908d36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/file-modal.vue
// module id = 1015
// module chunks = 0